export function FallbackView() {
  return (
    <div className="splash-screen">
      <span>Cargando ...</span>
    </div>
  );
}
